import fragmentTimestampToDateTime from './fragmentTimestampToDateTime';

export default fragmentTimestampToDateTime;
